import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getWebHookScriptFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.webHookUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getWebHookScriptFromServer][Store][Error occured while getting userGroupslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getTriggersFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.triggersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getTriggersFromServer][Store][Error occured while getting userGroupslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewWebHook(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.webHookUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewWebHook][Store][UserGroup add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewWebHook][Store][Error occured while adding UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateWebhookData(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.webHookUrl+"/"+payload.webhookId, payload.params);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateWebhookData][Store][User add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateWebhookData][Store][Error occured while adding user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async deleteExistingWebHook(context, payload = {}) {
    //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

    try {
        let resp = await axios.delete(`${Constants.webHookUrl}/${payload.webHookId}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[deleteExistingWebHook][Store][Tag Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[deleteExistingWebHook][Store][Error occured while deleting User--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },

};
